<template>
  <div
    class="min-h-screen max-w-full m-auto sm:px-14 bg-cover bg-center"
    :style="{
      backgroundImage: `url(${require('@/assets/images/bg.png')})`
    }"
  >
    <hero-header @toggle-sidebar="sidebarOpen = !sidebarOpen" @menuClick="menuOpen = !menuOpen" />
    <!-- Sidebar -->
    <transition name="slide">
      <HeroMenuMobile
        v-if="sidebarOpen"
        @toggle-sidebar="sidebarOpen = !sidebarOpen"
        class="block sm:hidden fixed inset-y-0 left-0 w-full h-full bg-white shadow-lg z-50 overflow-y-auto"
      />
    </transition>
    <div
      v-if="menuOpen"
      ref="menuRef"
      class="hidden sm:block absolute top-36 mt-2 z-50 left-0 right-0 sm:left-auto sm:right-14 sm:px-0"
    >
      <HeroMenu @menuClick="menuOpen = false" />
    </div>
    <div>
      <router-view />
    </div>
  </div>
</template>
<script>
import HeroMenuMobile from '@/components/common/HeroMenuMobile.vue';
import HeroMenu from '@/components/common/HeroMenu.vue';
import { ref } from 'vue';
export default {
  components: {
    HeroMenuMobile,
    HeroMenu
  },
  setup() {
    const sidebarOpen = ref(false);
    const menuOpen = ref(false);

    return {
      sidebarOpen,
      menuOpen
    };
  }
};
</script>
<style scoped>
/* Sidebar slide-in animation */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-from {
  transform: translateX(-100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}
</style>
